import React from 'react';
import '../App.css';
import thumbUp from '../images/thumb_up.png';
import thumbDown from '../images/thumb_down.png';
import thumbUpBlue from '../images/thumb_up_blue.png';
import thumbDownBlue from '../images/thumb_down_blue.png';
import PostEditor from './PostEditor';
import Comment from './Comment';
import BasicModal from './BasicModal';
import LocationMap from './LocationMap';
import TimeAgo from 'react-timeago';
import CommentCreator from './CommentCreator';

const baseUrl = window.location.protocol + '//' + window.location.host; 

export default class Post extends React.Component {

  constructor(props) {
    super(props);
    if (props && props.data && props.data.comments) {
      this.state = {comments: props.data.comments, commentPage: 0};
    } else {
      this.state = {commentPage: 1}; 
    }
  }

  upvote(event) {
    event.preventDefault();
    this.vote('up');
  }

  downvote(event) {
    event.preventDefault();
    this.vote('down');
  }

  async vote(direction) {
    let voteParams = {
      uri: `${baseUrl}/api/v1/posts/${this.props.data._id['$oid']}/${direction}vote`,
      method: 'PUT',
    };
    if (this.props.data && this.props.data.myvote && this.props.data.myvote.direction === direction) {
      // We have already voted this direction. Delete the vote.
      voteParams = {
        uri: `${baseUrl}/api/v1/posts/${this.props.data._id['$oid']}/vote`,
        method: 'DELETE',
      };
    }
    let that = this;
    try {
      const d = await fetch(voteParams.uri, voteParams);
      d.json().then(data => {
        let post = data['posts'];
        if (!post) {
          console.log('Something is wrong with our vote: ' + JSON.stringify(data));
          return;
        }
        // now set State so the post can redraw correctly.
        if (post && typeof post.upvotes !== 'undefined') {
          if (voteParams.method === 'DELETE') {
            delete that.props.data['myvote'];
            that.setState({upvotes: post.upvotes, downvotes: post.downvotes, voteDir: undefined});
          } else {
            that.props.data.myvote = {'direction': direction};
            that.setState({voteDir: direction, upvotes: post.upvotes, downvotes: post.downvotes});
          }
        } else {
          console.log('Something not defined in post body: ' + data.body);
        }
      });
    } catch(e) {
      console.log('Error putting vote data: ' + e);
    }
  }

  showProfile(e, user) {
    e.preventDefault();
    if (e.target.id !== 'unflag') {
      this.props.app.showProfile(user);
    }
  }

  fetchData(pid) {
    let that = this;
    let postId = pid || this.props.data._id['$oid'];
    // fetch(`${baseUrl}/api/v1/posts/${postId}?include_comments=true&include_stats=true`, function(err, data) {
    fetch(`/api/v1/posts/${postId}?include_comments=true&include_stats=true`, function(err, data) {
      if (err) {
        console.log('[Post] Error fetching data!: ' + err);
      } else {
        // Got data from the API... 
        let body = JSON.parse(data.body);
        that.setState({data: body.posts});
      }
    });
  }

  componentWillMount() {
    let data = this.state.data || this.props.data;
    if (!Object.keys(data).includes('comments') && !Object.keys(data).includes('conversation_id')) {
      // Maybe loaded from a notification. We need to fetch the rest of the data.. 
      this.fetchData();
    } else {
      if (!this.state.data) {
        this.setState({data: this.props.data});
      }
    }
  }  

  componentWillReceiveProps(newProps) {
    if (this.props.data._id['$oid'] !== newProps.data._id['$oid']) {
      this.setState({comments: [], comment_total: 0, commentPage: 0});
      this.fetchData(newProps.data._id['$oid']);
    }
  }

  fetchEarlierComments(e) {
    e.preventDefault();
    // Call for the next page of comments.. 
    let page = this.state.commentPage + 1;
    let that = this;
    // uri: `${baseUrl}/api/v1/posts/${this.props.data._id['$oid']}/comments?comment_page=${page}`,
    const uri = `/api/v1/posts/${this.props.data._id['$oid']}/comments?comment_page=${page}`;
    fetch(uri, function(err, data) {
      if (err) {
        console.log('Error fetching previous comments: ' + err);
      } else {
        // Should have data... 
        let comments = that.state.comments;
        let response = JSON.parse(data.body);
        for (let i = 0; i < response.comments.length; i++) {
          comments.push(response.comments[i]);
        }
        that.setState({comments: comments, comment_total: response.comment_total});
      }
    });
  }

  setCategory(event, cat) {
    event.preventDefault();
    this.props.app.setCategory(cat);
  }

  handlePollResponse(e, responseId) {
    let that = this;
    let pollParams = {
      uri: `${baseUrl}/api/v1/posts/${this.props.data._id['$oid']}/poll_responses/${responseId}`,
      method: 'POST',
    }
    // Hit API to register this poll response... 
    fetch(pollParams.uri, pollParams, function(err, data) {
      if (err) {
        console.log('Error responding to poll ' + this.props.data._id['$oid']);
        console.log('    Requested poll option id was: ' + responseId);
      } else {
        // game on.
        console.log('[Post] Got data from poll response: ' + JSON.stringify(data));
        let json = JSON.parse(data.body)['post'];
        that.setState({hasVoted: true, poll_options: json.poll_options});
      }
    });
  }

  hideBadPost(e) {
    e.preventDefault();
    if (e.target && e.target.id !== 'thumb' && e.target.id !== 'cat') {
      if (this.state.showBadPost) {
        this.setState({showBadPost: false});
      }
    }
  }

  pollOptionSort(a, b) {
    return b.count - a.count;
  }

  pollRatio(num, total) {
    return Math.floor((( 100 * num ) / total));
  }

  unflagPost(e) {
    e.preventDefault();
    let flagParams = { 
      uri: `${baseUrl}/api/v1/posts/${this.props.data._id['$oid']}/unflag`,
      method: 'PUT',
    };  
    let that = this;
    try {
      fetch(flagParams.uri, flagParams, function(err, data) {
        if (err) {
          console.log('Voting error: ' + err);
        } else {
          let post = JSON.parse(data.body)['posts'];
          if (!post) {
            console.log('Something is wrong with our vote: ' + data.body);
            return;
          } else {
            // Unmark this one bad. 
            that.setState({unflaggedPost: true, badPost: 'no', flaggedByUsername: ''});
          }   
        }   
      }); 
    } catch(err) {
      console.log('[Post] Error flagging post: ' + err);
    }   
  }

  flagPost(e) {
    e.preventDefault();
    let flagParams = {
      uri: `${baseUrl}/api/v1/posts/${this.props.data._id['$oid']}/flag`,
      method: 'PUT',
    };
    let that = this;
    try {
      fetch(flagParams.uri, flagParams, function(err, data) {
        if (err) {
          console.log('Voting error: ' + err);
        } else {
          let post = JSON.parse(data.body)['posts'];
          if (!post) {
            console.log('Something is wrong with our vote: ' + data.body);
            return;
          } else {
            // Mark this one bad. 
            that.setState({unflaggedPost: '', badPost: 'yes', flaggedByUsername: post.flagged_by.username});
          }
        }
      });
    } catch(err) {
      console.log('[Post] Error flagging post: ' + err);
    }
  }

  deletePost() {
    let that = this;
    fetch(`/api/v1/posts/${this.props.data._id['$oid']}`, {method: 'DELETE'}, function(err, data) {
      if (err) {
        console.log('[Post] Error deleting post!!!');
      } else {
        // Success. Now remove from timeline.. 
        console.log('[Post] Got data from delete post!: ' + JSON.stringify(data));
        let post = JSON.parse(data.body)['post'];
        console.log('[Post] Deleted post is: ' + JSON.stringify(post));
        that.setState({showDeleteConfirmation: false, visible: 'no'});
      }   
    }); 
  }

  initiateDelete(e) {
    if (e) e.preventDefault();
    this.setState({showDeleteConfirmation: true});
  }

  confirmDelete() {
    console.log('[Post] Confirm delete!!!');
    this.deletePost();
  }

  cancelDelete() {
    console.log('[Post] Cancel delete!!!');
    this.setState({showDeleteConfirmation: false});
  }

  editPost() {
    this.setState({editPost: true});
  }


  render() {
    if (this.state.visible === 'no') {
      return '';
    }
    let data = this.state.data || this.props.data;
    let map = '';
    if (data.location) {
      map = <LocationMap user={this.props.user} loc={data.location} />;
    }
    if (!Object.keys(data).includes('comments') && !Object.keys(data).includes('conversation_id')) {
      return '';
    }
    let imageUrl = undefined;
    let upThumb = thumbUp;
    let downThumb = thumbDown;
    let myVoteDirection = ''; 
    let upvotes = 0;
    let downvotes = 0;
    let role = '';
    if (this.state && this.state.voteDir) {
      myVoteDirection = this.state.voteDir;
    } else if (data && data.myvote) {
      myVoteDirection = data.myvote.direction;
    }
    if (this.state && typeof this.state.upvotes !== 'undefined') { 
      upvotes = this.state.upvotes;
      downvotes = this.state.downvotes;
    } else if (this.props && data && typeof data.upvotes !== 'undefined') {
      upvotes = data.upvotes;
      downvotes = data.downvotes;
    }
    if ( data.image_url && data.image_url.indexOf('missing.png') === -1) {
      imageUrl = window.location.protocol + data.image_url;
    }
    if (myVoteDirection) {
      if (myVoteDirection === 'down') {
        downThumb = thumbDownBlue;
      } else {
        upThumb = thumbUpBlue;
      }
    }
    let comments = [], postCategory = '', prevLink = '', commentTotal = this.state.comment_total;
    if (this.state.comments && this.state.comments.length > 0) {
      for (let i = 0; i < this.state.comments.length; i++) {
        let comment = this.state.comments[i];
        comments.push(<Comment data={comment} key={comment._id['$oid']} app={this.props.app} postObj={this} post={data} />);
      } 
    } else if (data && data.comments) {
      for (let i = 0; i < data.comments.length; i++) {
        let comment = data.comments[i];
        comments.push(<Comment data={comment} key={comment._id['$oid']} app={this.props.app} postObj={this} post={data} />);
      } 
    }
    if (comments.length && commentTotal > comments.length) {
      prevLink = <div className='prevLinkDiv'><span className='fakeLink' onClick={(e) => this.fetchEarlierComments(e)}><font className='commentActionFontBlue'>Mais comentários</font></span></div>;
    }
    if (data.post_category && data.post_category.name) {
      let linkColor = 'lightLink';
      if (this.props.badPost === 'yes') {
        linkColor = 'whiteLink';
      }
      postCategory = <div id='cat' className='postCategory'><span className='fakeLink' onClick={(e) => this.setCategory(e, data.post_category.name)}>
                       <font className={linkColor}>{data.post_category.name}</font>
                     </span></div>;
    }
    if (data.user.role) {
      if (data.user.role.name === 'Fundador') {
        role = <font className='fundadorRoleLabel'> &#9733;</font>;
      } else if (data.user.role.name === 'Moderador') {
        role = <font className='moderadorRoleLabel'> &#9733;</font>;
      } else {
        role = <b> &#9733;</b>;
      }
    } 
    let pollOptions = this.state.poll_options || data.poll_options || '';
    let pollDisplay = '';
    if (pollOptions) {
      pollOptions.sort(this.pollOptionSort);
      let pollElements = [];
      let hasVoted = this.state.hasVoted;
      for (let i = 0; i < pollOptions.length; i++) {
        if (pollOptions[i].is_user_response) {
          hasVoted = true;
        }
      } 
      let pollTotal = 0;
      if (hasVoted) {
        for (let i = 0; i < pollOptions.length; i++) {
          pollTotal += pollOptions[i].count;
        }
      }
      for (let i = 0; i < pollOptions.length; i++) {
        let po = pollOptions[i];
        pollElements.push(
          <div key={po._id['$oid']}>
            {hasVoted
              ? <div className='pollData'>{this.pollRatio(po.count, pollTotal)}% <div className='pollBar' style={{width: this.pollRatio(po.count, pollTotal)}}> </div> </div>
              : <input type='radio' checked={po.is_user_response} value={po._id['$oid']} onChange={(e) => this.handlePollResponse(e, po._id['$oid'])} />}
            <font className={po.is_user_response ? 'pollOptionDisplayBlue' : 'pollOptionDisplay'}>{po.label}</font>
          </div>
        );
      }
      pollDisplay = <form><br />{pollElements}</form>;
    } 
    let moderatorButton = '', unflagButton = '';
    // if (!Object.keys(data).includes('conversation_id')) {
    if (!data['conversation_id']) {
      if (this.props.current_user.role && (this.props.current_user.role.name === 'Fundador' || this.props.current_user.role.name === 'Moderador' ) && this.props.current_user.area_id['$oid'] === data.area_id['$oid']) {
        if (data.user.username !== this.props.current_user.username) {
          moderatorButton = <button className='smallSubmitButton' onClick={(e) => this.flagPost(e)} style={{float: 'right', backgroundColor: '#ff0000', marginTop: '-4px'}}>Denúncia</button>;
          unflagButton = <button id='unflag' className='smallSubmitButton' onClick={(e) => this.unflagPost(e)} style={{float: 'right', marginTop: '-4px'}}>Cancelar Denúncia</button>;
        }
      }
    } else {
      // Now check to see if the user is an admin or super admin within this conversation
      if (this.props.userConvoUser) {
        if (this.props.userConvoUser.conversation_role && this.props.userConvoUser.conversation_role.name.indexOf('Admin') !== -1) { 
          moderatorButton = <button className='smallSubmitButton' onClick={(e) => this.flagPost(e)} style={{float: 'right', backgroundColor: '#ff0000', marginTop: '-4px'}}>Denúncia</button>;
          unflagButton = <button id='unflag' className='smallSubmitButton' onClick={(e) => this.unflagPost(e)} style={{float: 'right', marginTop: '-4px'}}>Cancelar Denúncia</button>;
        }
      }
    }
    // if (( (!this.state.badPost || this.state.badPost === 'no') || this.state.showBadPost) && !data.flagged_by) {
    if ( this.state.unflaggedPost || this.state.showBadPost || ( (!this.state.badPost || this.state.badPost === 'no')  && !data.flagged_by && !this.state.flaggedByUsername) ) {
      let style = {marginBottom: '10px'};
      if (!data['conversation_id']) {
        style['marginTop'] = '-8px';
      } else {
        style['display'] = 'inline-block';
      }
      let deleteButton = '', editButton = '';
      if (this.props.current_user.username === data.user.username) {
        deleteButton = <button className='deleteButton' onClick={(e) => this.initiateDelete(e)}>Deletar</button>;
        editButton = <button className='editPostButton' onClick={(e) => this.editPost(e)}>Editar</button>;
      }
      let deleteConfirmation = '';
      if (this.state.editPost) {
        return <PostEditor placeHolder={this.props.title} imageFile={data.image_url} poll_options={data.poll_options} category={data.post_category.name} user={data.user} post={this} app={this.props.app} body={data.text} title={data.title} postId={data._id['$oid']} />;
      }
      if (this.state.showDeleteConfirmation) {
        deleteConfirmation = <BasicModal height='140px' buttonA={this.confirmDelete.bind(this)} buttonAlabel='Confirmar' buttonB={this.cancelDelete.bind(this)} buttonBlabel='Cancelar' modalTop={`Deletar ${data.title}?`} />;
      }
      return (
        <div id='post' style={style} onClick={(e) => this.hideBadPost(e)} ref={(ref) => this._post = ref}>
          {deleteConfirmation}
          <div className='post' style={{backgroundColor: this.state.showBadPost ? '#e7e9eb' : '#ffffff', 
              'border': 'solid ' + (data.post_category && data.post_category.name === 'Votaçao' ? '2px #99E592' : '1px #cccccc')}}>
            {this.state.showBadPost ? '' : moderatorButton} {editButton} {deleteButton} {postCategory} {this.state.showBadPost ? unflagButton : ''}
            <div className='postHeader'>
              <span className='fakeLink' onClick={(e) => this.showProfile(e, data.user)}><img className='avatar' src={data.user.avatar} alt='' /></span>
              <div className='postHeaderText'>
                <div>
                  <span className='fakeLink' onClick={(e) => this.showProfile(e, data.user)}>{data.user.username}</span>{role}
                </div>
                <span className='timeAgo'><TimeAgo date={data.created_at} /></span>
              </div>
            </div>
            <div className='postTitleText' >{data.title}</div>
            <br />
            { imageUrl ? <div className='postImageFrame'><img className='postImage' src={imageUrl} alt='' /><br /></div> : '' }
            <div className='postBody'>{data.text}</div>
            {pollDisplay}
            {map}
            <hr className='postHr' />
            <div className='postStats'>
              <img id='thumb' className='thumb' onClick={(e) => this.upvote(e)} src={upThumb} alt='thumbUp' /><div className='gostaText'>{upvotes}</div>
              &nbsp;&nbsp;
              <img id='thumb' className='thumb' onClick={(e) => this.downvote(e)} src={downThumb} alt='thumbDown'  /><div className='gostaText'>{downvotes}</div>
            </div>
          </div>
          {comments}
          {prevLink}
          {data.conversation_id ? '' : <CommentCreator post={data} postObj={this} user={this.props.current_user} />}
        </div>
      );
            // <div className='postStats'>
              // {upvotes} Gosta / {downvotes} Não Gosta
            // </div>
    } else {
      // Bad post..  No biscuit.
      let badMessage = 'Postagem removida devido ao número de votos ou moderação';
      if (data.flagged_by) {
        badMessage = 'Postagem removida por ' + data.flagged_by.username;
      } else if (this.state.badPost && this.state.badPost === 'yes') {
        badMessage = 'Postagem removida por ' + this.state.flaggedByUsername;
      }
      return(
        <div>
          <div className='badPost'>
             <span className='fakeLink' onClick={(e) => {e.preventDefault(); this.setState({showBadPost: true})}}>{badMessage}</span> {postCategory}
          </div>
        </div>
      );
    }
  }
}

